import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GlobeService } from './globe.service';

@Injectable({
    providedIn: 'root',
})
export class PopupService {
    private popupStatus = new Subject<any>();

    constructor() {}

    setPopupStatus(message) {
        this.popupStatus.next(message);
    }

    getPopupStatus(): Observable<any> {
        return this.popupStatus.asObservable();
    }
}
